import * as data from "../actions/pharmacies.data";
import * as ui from "../actions/pharmacies.ui";

export interface State {
	savingPharmacy: boolean;
}

export const initialState: State = {
	savingPharmacy: false,
};

export function reducer(state = initialState, action: data.Actions | ui.Actions): State {
	switch (action.type) {
		case ui.SAVING_PHARMACY:
			return {
				...state,
				savingPharmacy: true,
			};
		case data.UPDATE_PHARMACY:
			return {
				...state,
				savingPharmacy: false,
			};
		default:
			return state;
	}
}

export const getSavingPharmacy = (state: State) => state.savingPharmacy;
